import { render, staticRenderFns } from "./PaymentTypeList_Action.vue?vue&type=template&id=5b3d6544&"
import script from "./PaymentTypeList_Action.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeList_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports